import { useMutation, useQueryClient } from "react-query";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useDeleteErrorLog = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, { id: string }>(
    ({ id }) => mutateDeleteFn(
      ENDPOINTS.ERROR_LOG_DELETE.replace(":id", id),
      {}
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.ERROR_LOGS]);
      },
    }
  );
};
